<template>
  <div class="go-in">
    <banner :img="bgtop" :title="$t('title.aboutUs')" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">{{ $t('aboutUs.aboutUs') }}</p>
            <p class="eTitle"></p>
            <p class="content">
              {{ $t('aboutUs.aboutUsText')}}
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/company-pic.jpg" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>

        <!-- 发展历程 -->
<!--        <div class="content-course">-->
<!--          <div class="top">-->
<!--            <h3>{{ $t('aboutUs.developmentHistory') }}</h3>-->
<!--            <p></p>-->
<!--            <div class="border"></div>-->
<!--            <div class="timeline"></div>-->
<!--          </div>-->
<!--          <div class="course-time">-->
<!--            <swiper :options="swiperOption" ref="mySwiper">-->
<!--              <swiper-slide v-for="(item,index) in courseList" :key="index">-->
<!--                <div class="time-show">-->
<!--                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">-->
<!--                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>-->
<!--                    <el-divider>-->
<!--                      <i class="el-icon-mobile-phone"></i>-->
<!--                    </el-divider>-->
<!--                    <div class="item-bottom" :class="{'order' : one%2===1}">-->
<!--                      <div class="item-bottom-content">-->
<!--                        <p>{{courseOne.Content}}</p>-->
<!--                        <p>{{courseOne.Year}}</p>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </swiper-slide>-->
<!--              <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--              <div class="swiper-button-next" slot="button-next"></div>-->
<!--            </swiper>-->
<!--          </div>-->
<!--        </div>-->

        <!-- 企业文化-->
<!--        <div class="content-culture">-->
<!--          <h3>{{ $t('aboutUs.corporateCulture') }}</h3>-->
<!--          <h3></h3>-->
<!--          <span>{{ $t('aboutUs.corporateCultureText1') }}</span>-->
<!--          <span>{{ $t('aboutUs.corporateCultureText2') }}</span>-->
<!--          <span>{{ $t('aboutUs.corporateCultureText3') }}</span>-->
<!--          <span>{{ $t('aboutUs.corporateCultureText4') }}</span>-->
<!--          <span>{{ $t('aboutUs.corporateCultureText5') }}</span>-->
<!--        </div>-->

        <!-- 公司荣誉 -->
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <h3>{{ $t('aboutUs.qualificationAndHonor') }}</h3>
            <p></p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index">
              <img
                v-lazy="honor.Img" :title="honor.Remark"
                @click="dialogTableVisible = true ;dialogUrl = honor.BigImg;dialogTitle= honor.Remark"
              />
            </li>
          </ul>
          <p>{{ $t('aboutUs.clickImage') }}</p>
        </div>

        <!-- 团队风采 -->
<!--        <div class="content-team">-->
<!--          <div class="top">-->
<!--            <h3>{{ $t('aboutUs.team') }}</h3>-->
<!--            <p></p>-->
<!--            <div class="border"></div>-->
<!--            <p></p>-->
<!--          </div>-->
<!--          <el-carousel :interval="4000" type="card">-->
<!--            <el-carousel-item v-for="(team,index) in teamItem" :key="index">-->
<!--              <div class="swiper-img" v-lazy:background-image="team.Img"></div>-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--        </div>-->

        <!-- 合作伙伴 -->
<!--        <div class="content-partner">-->
<!--          <div class="top">-->
<!--            <h3>{{ $t('aboutUs.cooperativePartner') }}</h3>-->
<!--            <p></p>-->
<!--            <div class="border"></div>-->
<!--            <ul class="partner-img">-->
<!--              <li v-for="(partner,i) in partnerImg" :key="i">-->
<!--                <img v-lazy="partner.Img" alt />-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->

      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
// import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      loading: false,  // true转圈
      courseList: [],
      honorList: [],
      teamItem: [],
      partnerImg: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      bgtop: require('@/assets/img/bgtop22.jpg'),
    };
  },
  mounted() {
    this.teamItem = [
      {"Id":12,"Img":require('@/assets/img/company-team-1.jpg'),"Remark":"1","CreateTime":"2023-11-29T13:50:15.743"},
      {"Id":11,"Img":require('@/assets/img/company-team-2.jpg'),"Remark":"2","CreateTime":"2020-06-05T21:34:41.023"},
      {"Id":10,"Img":require('@/assets/img/company-team-3.jpg'),"Remark":"3","CreateTime":"2020-06-05T21:34:36.397"},
      {"Id":9,"Img":require('@/assets/img/company-team-4.jpg'),"Remark":"4","CreateTime":"2020-06-05T21:34:36.397"},
      {"Id":8,"Img":require('@/assets/img/company-team-5.jpg'),"Remark":"5","CreateTime":"2020-06-05T21:34:36.397"},
    ]
    this.partnerImg = [
      {"Id":30,"Img":require('@/assets/img/company-partner.png'),"Remark":"1","CreateTime":"2024-10-19T08:58:39.233"},
      {"Id":31,"Img":require('@/assets/img/company-partner.png'),"Remark":"2","CreateTime":"2024-10-19T08:58:59.5"},
      {"Id":32,"Img":require('@/assets/img/company-partner.png'),"Remark":"3","CreateTime":"2024-10-19T09:00:37.057"},
      {"Id":36,"Img":require('@/assets/img/company-partner.png'),"Remark":"4","CreateTime":"2024-11-20T07:29:03.26"}
    ]
    if(this.$i18n.locale === 'zh-CN') {
      this.honorList = [
        {"Id":10,"Img":require('@/assets/img/ccompany-honor-COC-20230510.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230510.jpg'),"Remark":"COC 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":11,"Img":require('@/assets/img/ccompany-honor-COC-20230718.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230718.jpg'),"Remark":"COC 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":12,"Img":require('@/assets/img/ccompany-honor-MHRA-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20231219.jpg'),"Remark":"MHRA 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":13,"Img":require('@/assets/img/ccompany-honor-MHRA-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20240411.jpg'),"Remark":"MHRA 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":14,"Img":require('@/assets/img/ccompany-honor-MHRA-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20241028.jpg'),"Remark":"MHRA 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":15,"Img":require('@/assets/img/ccompany-honor-RoHS-20240408.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240408.jpg'),"Remark":"RoHS 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":16,"Img":require('@/assets/img/ccompany-honor-RoHS-20240531.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240531.jpg'),"Remark":"RoHS 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":17,"Img":require('@/assets/img/ccompany-honor-RoHS-20241023.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241023.jpg'),"Remark":"RoHS 证书","CreateTime":"2023-11-29T13:34:39.59"},
        {"Id":18,"Img":require('@/assets/img/ccompany-honor-RoHS-20241212.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241212.jpg'),"Remark":"RoHS 证书","CreateTime":"2023-11-29T13:34:04.613"},
        {"Id":19,"Img":require('@/assets/img/ccompany-honor-TPD-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20231219.jpg'),"Remark":"TPD 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":20,"Img":require('@/assets/img/ccompany-honor-TPD-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20240411.jpg'),"Remark":"TPD 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":21,"Img":require('@/assets/img/ccompany-honor-TPD-20230721.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20230721.jpg'),"Remark":"TPD 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":22,"Img":require('@/assets/img/ccompany-honor-TPD-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20241028.jpg'),"Remark":"TPD 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":23,"Img":require('@/assets/img/ccompany-honor-VOC-20230309.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20230309.jpg'),"Remark":"VOC 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":24,"Img":require('@/assets/img/ccompany-honor-VOC-20241024.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241024.jpg'),"Remark":"VOC 证书","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":25,"Img":require('@/assets/img/ccompany-honor-VOC-20241218.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241218.jpg'),"Remark":"VOC 证书","CreateTime":"2023-11-29T13:33:31.717"},
      ]
      this.courseList = [
        [{"Id":10,"Year":"2007年9月","Content":"CCT（HK）LIMITED成立"},{"Id":11,"Year":"2009年11月","Content":"CCT（HK）LIMITED第一家专卖店在香港开业。"}],
        [{"Id":12,"Year":"2013年11月","Content":"CCT（HK）LIMITED品质中心投入使用"},{"Id":14,"Year":"2015年3月","Content":"CCT（HK）LIMITED雾化实验室投入使用。"}],
        [{"Id":17,"Year":"2018年9月","Content":"CCT（HK）LIMITED专属工厂投产"},{"Id":18,"Year":"2019年5月","Content":"CCT（HK）LIMITED获得“德国红点奖”"}],
        [{"Id":20,"Year":"2020年11月","Content":"公司成功通过CNAS认证。"},{"Id":19,"Year":"2022年3月","Content":"启用生命科学实验室"}]]
    } else if(this.$i18n.locale === 'zh-TW') {
      this.honorList = [
        {"Id":10,"Img":require('@/assets/img/ccompany-honor-COC-20230510.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230510.jpg'),"Remark":"COC 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":11,"Img":require('@/assets/img/ccompany-honor-COC-20230718.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230718.jpg'),"Remark":"COC 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":12,"Img":require('@/assets/img/ccompany-honor-MHRA-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20231219.jpg'),"Remark":"MHRA 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":13,"Img":require('@/assets/img/ccompany-honor-MHRA-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20240411.jpg'),"Remark":"MHRA 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":14,"Img":require('@/assets/img/ccompany-honor-MHRA-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20241028.jpg'),"Remark":"MHRA 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":15,"Img":require('@/assets/img/ccompany-honor-RoHS-20240408.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240408.jpg'),"Remark":"RoHS 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":16,"Img":require('@/assets/img/ccompany-honor-RoHS-20240531.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240531.jpg'),"Remark":"RoHS 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":17,"Img":require('@/assets/img/ccompany-honor-RoHS-20241023.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241023.jpg'),"Remark":"RoHS 證書","CreateTime":"2023-11-29T13:34:39.59"},
        {"Id":18,"Img":require('@/assets/img/ccompany-honor-RoHS-20241212.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241212.jpg'),"Remark":"RoHS 證書","CreateTime":"2023-11-29T13:34:04.613"},
        {"Id":19,"Img":require('@/assets/img/ccompany-honor-TPD-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20231219.jpg'),"Remark":"TPD 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":20,"Img":require('@/assets/img/ccompany-honor-TPD-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20240411.jpg'),"Remark":"TPD 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":21,"Img":require('@/assets/img/ccompany-honor-TPD-20230721.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20230721.jpg'),"Remark":"TPD 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":22,"Img":require('@/assets/img/ccompany-honor-TPD-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20241028.jpg'),"Remark":"TPD 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":23,"Img":require('@/assets/img/ccompany-honor-VOC-20230309.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20230309.jpg'),"Remark":"VOC 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":24,"Img":require('@/assets/img/ccompany-honor-VOC-20241024.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241024.jpg'),"Remark":"VOC 證書","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":25,"Img":require('@/assets/img/ccompany-honor-VOC-20241218.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241218.jpg'),"Remark":"VOC 證書","CreateTime":"2023-11-29T13:33:31.717"},
      ]
      this.courseList = [
        [{"Id":10,"Year":"2007年9月","Content":"CCT（HK）LIMITED成立"},{"Id":11,"Year":"2009年11月","Content":"CCT（HK）LIMITED第一家專賣店在香港開業。"}],
        [{"Id":12,"Year":"2013年11月","Content":"CCT（HK）LIMITED品質中心投入使用"},{"Id":14,"Year":"2015年3月","Content":"CCT（HK）LIMITED霧化實驗室投入使用。"}],
        [{"Id":17,"Year":"2018年9月","Content":"CCT（HK）LIMITED專屬工廠投產"},{"Id":18,"Year":"2019年5月","Content":"CCT（HK）LIMITED獲得“德國紅點獎”"}],
        [{"Id":20,"Year":"2020年11月","Content":"公司成功通過CNAS認證。"},{"Id":19,"Year":"2022年3月","Content":"啟用生命科學實驗室"}]]
    } else if(this.$i18n.locale === 'en') {
      this.honorList = [
        {"Id":10,"Img":require('@/assets/img/ccompany-honor-COC-20230510.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230510.jpg'),"Remark":"COC Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":11,"Img":require('@/assets/img/ccompany-honor-COC-20230718.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230718.jpg'),"Remark":"COC Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":12,"Img":require('@/assets/img/ccompany-honor-MHRA-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20231219.jpg'),"Remark":"MHRA Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":13,"Img":require('@/assets/img/ccompany-honor-MHRA-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20240411.jpg'),"Remark":"MHRA Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":14,"Img":require('@/assets/img/ccompany-honor-MHRA-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20241028.jpg'),"Remark":"MHRA Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":15,"Img":require('@/assets/img/ccompany-honor-RoHS-20240408.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240408.jpg'),"Remark":"RoHS Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":16,"Img":require('@/assets/img/ccompany-honor-RoHS-20240531.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240531.jpg'),"Remark":"RoHS Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":17,"Img":require('@/assets/img/ccompany-honor-RoHS-20241023.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241023.jpg'),"Remark":"RoHS Certificate","CreateTime":"2023-11-29T13:34:39.59"},
        {"Id":18,"Img":require('@/assets/img/ccompany-honor-RoHS-20241212.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241212.jpg'),"Remark":"RoHS Certificate","CreateTime":"2023-11-29T13:34:04.613"},
        {"Id":19,"Img":require('@/assets/img/ccompany-honor-TPD-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20231219.jpg'),"Remark":"TPD Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":20,"Img":require('@/assets/img/ccompany-honor-TPD-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20240411.jpg'),"Remark":"TPD Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":21,"Img":require('@/assets/img/ccompany-honor-TPD-20230721.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20230721.jpg'),"Remark":"TPD Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":22,"Img":require('@/assets/img/ccompany-honor-TPD-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20241028.jpg'),"Remark":"TPD Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":23,"Img":require('@/assets/img/ccompany-honor-VOC-20230309.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20230309.jpg'),"Remark":"VOC Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":24,"Img":require('@/assets/img/ccompany-honor-VOC-20241024.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241024.jpg'),"Remark":"VOC Certificate","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":25,"Img":require('@/assets/img/ccompany-honor-VOC-20241218.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241218.jpg'),"Remark":"VOC Certificate","CreateTime":"2023-11-29T13:33:31.717"},
      ]
      this.courseList = [
        [{"Id":10,"Year":"September 2007","Content":"CCT (HK) LIMITED established"},{"Id":11,"Year":"November 2009","Content":"CCT (HK) LIMITED's first exclusive store opened in Hong Kong."}],
        [{"Id":12,"Year":"November 2013","Content":"CCT (HK) LIMITED Quality Center put into use"},{"Id":14,"Year":"March 2015","Content":"CCT (HK) LIMITED Atomization Laboratory has been put into use."}],
        [{"Id":17,"Year":"September 2018","Content":"CCT (HK) LIMITED's exclusive factory is put into operation"},{"Id":18,"Year":"May 2019","Content":"CCT (HK) LIMITED wins the \"German Red Dot Award\"”"}],
        [{"Id":20,"Year":"November 2020","Content":"The company has successfully passed CNAS certification。"},{"Id":19,"Year":"March 2022","Content":"Activate Life Science Laboratory"}]]
    } else if(this.$i18n.locale === 'es') {
      this.honorList = [
        {"Id":10,"Img":require('@/assets/img/ccompany-honor-COC-20230510.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230510.jpg'),"Remark":"Certificado COC","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":11,"Img":require('@/assets/img/ccompany-honor-COC-20230718.jpg'),"BigImg":require('@/assets/img/company-honor-COC-20230718.jpg'),"Remark":"Certificado COC","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":12,"Img":require('@/assets/img/ccompany-honor-MHRA-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20231219.jpg'),"Remark":"Certificado MHRA","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":13,"Img":require('@/assets/img/ccompany-honor-MHRA-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20240411.jpg'),"Remark":"Certificado MHRA","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":14,"Img":require('@/assets/img/ccompany-honor-MHRA-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-MHRA-20241028.jpg'),"Remark":"Certificado MHRA","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":15,"Img":require('@/assets/img/ccompany-honor-RoHS-20240408.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240408.jpg'),"Remark":"Certificado RoHS","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":16,"Img":require('@/assets/img/ccompany-honor-RoHS-20240531.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20240531.jpg'),"Remark":"Certificado RoHS","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":17,"Img":require('@/assets/img/ccompany-honor-RoHS-20241023.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241023.jpg'),"Remark":"Certificado RoHS","CreateTime":"2023-11-29T13:34:39.59"},
        {"Id":18,"Img":require('@/assets/img/ccompany-honor-RoHS-20241212.jpg'),"BigImg":require('@/assets/img/company-honor-RoHS-20241212.jpg'),"Remark":"Certificado RoHS","CreateTime":"2023-11-29T13:34:04.613"},
        {"Id":19,"Img":require('@/assets/img/ccompany-honor-TPD-20231219.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20231219.jpg'),"Remark":"Certificado TPD","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":20,"Img":require('@/assets/img/ccompany-honor-TPD-20240411.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20240411.jpg'),"Remark":"Certificado TPD","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":21,"Img":require('@/assets/img/ccompany-honor-TPD-20230721.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20230721.jpg'),"Remark":"Certificado TPD","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":22,"Img":require('@/assets/img/ccompany-honor-TPD-20241028.jpg'),"BigImg":require('@/assets/img/company-honor-TPD-20241028.jpg'),"Remark":"Certificado TPD","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":23,"Img":require('@/assets/img/ccompany-honor-VOC-20230309.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20230309.jpg'),"Remark":"Certificado VOC","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":24,"Img":require('@/assets/img/ccompany-honor-VOC-20241024.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241024.jpg'),"Remark":"Certificado VOC","CreateTime":"2023-11-29T13:33:31.717"},
        {"Id":25,"Img":require('@/assets/img/ccompany-honor-VOC-20241218.jpg'),"BigImg":require('@/assets/img/company-honor-VOC-20241218.jpg'),"Remark":"Certificado VOC","CreateTime":"2023-11-29T13:33:31.717"},
      ]
      this.courseList = [
        [{"Id":10,"Year":"Septiembre de 2007","Content":"Se crea CCT (hk) Limited"},{"Id":11,"Year":"Noviembre de 2009","Content":"La primera tienda especializada de CCT (hk) Limited abrió sus puertas en Hong kong."}],
        [{"Id":12,"Year":"Noviembre de 2013","Content":"Se pone en funcionamiento el Centro de calidad CCT (hk) Limited"},{"Id":14,"Year":"Marzo de 2015","Content":"Se puso en funcionamiento el laboratorio de atomización CCT (hk) Limited."}],
        [{"Id":17,"Year":"Septiembre de 2018","Content":"Puesta en funcionamiento de la planta exclusiva de CCT (hk) Limited"},{"Id":18,"Year":"Mayo 2019","Content":"CCT (hk) Limited ganó el \"premio punto rojo alemán\""}],
        [{"Id":20,"Year":"Noviembre 2020","Content":"La compañía pasó con éxito la certificación cnas."},{"Id":19,"Year":"Marzo 2022","Content":"Inauguración del laboratorio de Ciencias de la vida"}]]
    }

    // this.$http
    //   .all([
    //     this.$http.get("Honor/GetHonorAll"),
    //     this.$http.get("Enterprise/GetEnterpriseAll"),
    //     this.$http.get(`Team/GetTeamAll`),
    //     this.$http.get(`Course/GetCourseAll`)
    //   ])
    //   .then(
    //     this.$http.spread(
    //       (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
            // this.honorList = responseHonor.data;
            // this.partnerImg = responseEnterprise.data;
            // this.teamItem = responseTeam.data;

            // var groupCount = Math.ceil(responseCourse.data.length / 2);
            // window.console.log(groupCount);
            // for (let i = 0; i < groupCount; i++) {
            //   let img2 = [];
            //   for (let j = 0; j < 2; j++) {
            //     if (responseCourse.data.length - 1 >= i * 2 + j) {
            //       img2.push(responseCourse.data[i * 2 + j]);
            //     }
            //   }
            //   this.courseList.push(img2);
            // }
            // window.console.log(JSON.stringify(this.courseList));
            // window.console.log(JSON.stringify(this.honorList));
            // window.console.log(JSON.stringify(this.partnerImg));
            // window.console.log(JSON.stringify(this.teamItem));
        //     this.loading = false;
        //   }
        // )
      // );
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #F5F7FA;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 77.5rem; // 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 6.25rem 0; // 100px 0;
        .summary-left {
          width: 37.5rem; // 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #18191A;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 25rem; // 400px;
          height: 19.375rem; // 310px;
          border: 2px solid #18191A;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 5rem; // 80px;
          text-align: center;

          img {
            width: 22.5rem; // 360px;
            height: 16.875rem; // 270px;
            margin-top: 1.25rem; // 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #18191A;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #18191A;
        h3 {
          color: #fff;
          font-size: 26px;
        }
        p {
          color: #fff;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          color: #fff;
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 3.125rem 0 ; // 50px 0;
        .honor-show {
          width: 71.8rem; // 1000px;
          margin: 3.75rem auto; // 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;
          cursor:pointer;

          li {
            width: 16.69rem; // 220px;
            height: 24rem; // 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #18191A;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .go-in {
    width: 100%;
    height: 100%;
    background-color: #F5F7FA;
    position: relative;
    overflow: hidden;
    .section {
      width: 100%;
      &-content {
        width: 100%;
        margin: 0 auto;
        background-color: #fff;

        .content-summary {
          display: flex;
          justify-content: space-around;
          padding: 10% 0; // 100px 0;
          .summary-left {
            width: 40%;
            .title {
              font-size: 25px;
              color: #e13834;
            }
            .eTitle {
              font-size: 17px;
              color: #e13834;
              padding: 20px 0;
            }
            .content {
              color: #18191A;
              font-size: 14px;
              text-indent: 25px;
              line-height: 30px;
            }
          }

          .summary-right {
            width: 50%;
            height: 30%;
            border: 2px solid #18191A;
            //animation: imgboxkey 4s infinite;
            border-radius: 10px;
            margin-top: 5rem; // 80px;
            text-align: center;

            img {
              width: 88%;
              height: 30%;
              margin: 1.25rem 0 1.25rem 0; // 20px;
              //animation: imgbo 4s infinite;
            }
          }
        }

        //发展历程
        .content-course {
          padding: 50px 0;
          .course-time {
            width: 1000px;
            height: 400px;
            margin: 20px auto;
            .swiper-container {
              height: 100%;
            }
            .time-show {
              width: 700px;
              height: 100%;
              margin: 0 auto;
              display: flex;
              .time-show-item {
                width: 350px;
                height: 100%;
                overflow: hidden;
                display: flex;
                flex-direction: column;

                .item-top,
                .item-bottom {
                  height: 190px;
                }
                .item-bottom {
                  // display: flex;
                  // align-content: center;
                  .item-bottom-content {
                    background-color: #18191A;
                    margin: 20px 0;
                    p {
                      color: #fff;
                      text-align: center;
                      padding: 15px;
                    }
                  }
                }
              }
            }
          }
        }

        //企业文化
        .content-culture {
          height: 450px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding-left: 100px;
          background-color: #18191A;
          h3 {
            color: #fff;
            font-size: 26px;
          }
          p {
            color: #fff;
            font-size: 26px;
            padding: 5px 0;
          }
          span {
            color: #fff;
            font-weight: 400;
            line-height: 36px;
            font-size: 18px;
            padding: 5px 0;
          }
        }

        //公司荣誉
        .content-honor {
          padding: 3.125rem 0 ; // 50px 0;
          .honor-show {
            width: 100%;
            margin: 3.75rem auto; // 30px auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-content: flex-start;
            cursor:pointer;

            li {
              width: 44%;
              height: 20rem; // 320px;
              margin-left: 15px;
              list-style: none;
              border: 1px solid palegoldenrod;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          p {
            text-align: center;
            color: #18191A;
          }
        }

        //团队风采
        .content-team {
          padding: 50px 100px;
          .swiper-img {
            height: 400px;
            background: no-repeat center;
            background-size: cover;
          }
        }

        //合作伙伴
        .content-partner {
          padding: 50px 0;
          .partner-img {
            width: 950px;
            margin: 20px auto;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            li {
              width: 107px;
              height: 107px;
              list-style: none;
              margin: 10px 25px;

              img {
                width: 100%;
                height: 100%;
                border: 1px solid rgb(194, 218, 235);
              }
            }
          }
        }
      }
    }
  }
}


@keyframes imgboxkey {
  0% {
    border: solid #18191A 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid #18191A 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #18191A;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #18191A;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #18191A;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>
